import { CalendarListing } from '@/types';
import { EventImpl } from '@fullcalendar/core/internal';
import { Popover, Box } from '@mui/material';
import {
  CloseIcon,
  Typography,
  useTheme,
} from '@silverstein-properties/inspirelabs-ui';
import { EventItem } from '../CalendarView/EventItem';
import { formatDate } from '@/utils';

export const MoreEventsPopover = ({
  anchorEl,
  onClose,
  event,
}: {
  anchorEl?: HTMLElement;
  event?: EventImpl;
  onClose: () => void;
}) => {
  const theme = useTheme();
  const open = Boolean(anchorEl);

  const handleClose = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      onClose();
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      closeAfterTransition={false}
      sx={{
        '& .MuiPaper-root': {
          width: 220,
          borderRadius: 0,
        },
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.grey[200],
          p: theme.spacers.xs,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body2">
          {formatDate(event?.start || '')}
        </Typography>
        <CloseIcon
          onClick={handleClose}
          width={theme.constants.ICON_SIZE.small}
          height={theme.constants.ICON_SIZE.small}
        />
      </Box>
      <Box
        sx={{
          p: theme.spacing(1.25),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacers.xxs,
        }}
      >
        {event?.extendedProps?.eventsGroup?.map((event: CalendarListing) => (
          <EventItem key={event.id} event={event} />
        ))}
      </Box>
    </Popover>
  );
};
